import pages from './pages';
import displays from './displays';
import terminals from './terminals';
import { Message } from './components';
import appActions from './actions';
import { MODE } from './constants';
import storage from './storage';
import { bickActions, joinPath } from './common';
import debug from './debug';

import { Route, Switch } from 'react-router-dom';
import { connect, Provider } from 'react-redux';
import React, { Component } from 'react';
import { pick } from 'lodash';

// TODO: Use Hashids.
/*
import Hashids from 'hashids';

console.warn('Be more smart about the key...');
const hashids = new Hashids('Nosturi');
*/

class App extends Component {
  state = { error: {}, messages: [] };

  onMessageDismiss = (event, message) => {
    this.setState(state => ({
      ...state,
      messages: state.messages.filter(({ id }) => id !== message.id),
    }));
  };

  setMessage(message) {
    this.setState(state => ({
      ...state,
      messages: [
        ...state.messages.filter(({ id }) => id !== message.id),
        message,
      ],
    }));
  }

  onServiceWorkerCached = () => {
    // Content is cached for offline use.
  };

  onServiceWorkerOffline = () => {
    this.setMessage({
      id: 'nosturi-service-worker-offline',
      content: 'No internet connection found. App is running in offline mode.',
      warning: true,
    });
  };

  onServiceWorkerUpdateInstalled = () => {
    this.setMessage({
      id: 'nosturi-service-worker-update-installed',
      content:
        'App update is available. Save all work and reload page to activate.',
      positive: true,
    });
  };

  onServiceWorkerError = error => {
    console.error('SERVICE WORKER ERROR!', error);
  };

  onClearData = () => {
    storage.clear();
    window.location.reload();
  };

  componentDidMount() {
    const { mode, app, actions, route } = this.props;
    if (mode === MODE.CONNECT) {
      const { params } = route.match;

      const { host, protocol } = window.location;
      const secure = protocol === 'https:';
      const address = `${secure ? 'wss' : 'ws'}://${host}`;

      actions.app.connect({
        address,
        ...pick(app, 'identity'),
        ...pick(params, 'roomKey'),
      });
    }
    debug('App did mount');
  }

  componentDidUpdate() {
    debug('App did update');
  }

  componentWillUnmount() {
    debug('App will unmount');
  }

  componentDidCatch(exception, info) {
    this.setState({ error: { exception, info } });
  }

  render() {
    const { error } = this.state;
    if (error.exception) {
      return (
        <main>
          <h1>{error.exception.toString()}</h1>
          <details>
            <pre>{error.info.componentStack}</pre>
          </details>
          {storage && (
            <button onClick={this.onClearData}>Clear all data!</button>
          )}
        </main>
      );
    }

    const { mode, store, route } = this.props;
    const { messages } = this.state;

    const appProps = {
      mode,
      pages,
      terminals,
      displays,
      messages: messages.map(message => (
        <Message
          key={message.id}
          onDismiss={this.onMessageDismiss}
          {...message}
        />
      )),
    };

    const baseUrl = route.match.url;
    const pageRoutes = [...pages, ...terminals, ...displays].map(Page => (
      <Route
        key={Page.slug}
        exact={Page.slug === ''}
        path={joinPath(baseUrl, Page.slug)}
        render={routeProps => (
          <Page app={appProps} route={{ ...routeProps, baseUrl }} />
        )}
      />
    ));

    return (
      <Provider store={store}>
        <Switch>
          {pageRoutes}
          <Route>
            <main>
              <h1>Not Found</h1>
              Return to <a href={route.match.url}>homepage</a>.
            </main>
          </Route>
        </Switch>
      </Provider>
    );
  }
}

const mapStateToProps = ({ app }) => ({ app });

const mapDispatchToProps = dispatch => ({
  actions: {
    app: bickActions(appActions, ['connect', 'disconnect'], dispatch),
  },
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);



// WEBPACK FOOTER //
// ./src/App.js